<template>
<div id="nissan-quiz-majorwinner-ipad" class="nissan-quiz-screen">
  <div class="winTitle">GRAND PRIZE<br>WINNER!</div>
  <div class="winTagline01">SEE A BRAND AMBASSADOR<br>TO CLAIM YOUR PRIZE!</div>
  <!-- <div class="winTagline02">THRILL MACHINE FAST PASS!</div> -->
  <input
    v-if="config.tierType === 'TIER2' || config.tierType === 'TSF' || config.tierType === 'CORP' || config.tierType === 'TIER1'"
    v-model="claimCode"
    type="text"
    maxlength="4"
    class="nissan-quiz-claimbutton"
    id="nissan-quiz-claimbutton"
    name="claimcode"
    placeholder="CLAIM CODE"
    required
  />
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WinnerBig',
  computed: {
    ...mapGetters([
      'config',
      'gameRoomId',
    ]),
    claimCode: {
      get() {
        return this.$store.state.claimCode;
      },
      set(value) {
        this.$store.commit('setClaimCode', { value });
      },
    },
  },
  mounted() {
    this.$store.commit('setClaimCode', { value: '' });
  },
  watch: {
    claimCode(newVal) {
      if (newVal === '3467') {
        this.$store.commit('setTriggerDisconnect', { value: true });

        this.$keen.recordEvent('claimCode', {
          item: 'Grand prize Winner',
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
@import './../styles/_global.scss';
@import './../styles/_variables.scss';

#nissan-quiz-majorwinner-ipad {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.winTitle {
  font-size: 65px;
  line-height: 55px;
  text-align: center;
  width: 100%;
  margin-top: 40px;
  font-family: 'Nissan-Brand-Bold';
}

.winTagline01 {
  margin-top: 20px;
  text-align: center;
  width: 100%;
  font-family: 'Nissan-Brand-Bold';
  font-size: 30px;
}

.winTagline02 {
  text-align: center;
  width: 100%;
  font-family: 'Nissan-Brand-Light';
  font-size: 30px;
}
@media only screen and (max-width: 320px) {
  .winTitle {
    font-size: 80px;
    line-height: 60px;
    margin-top: 0px;
  }

  .winTagline01 {
    margin-top: 10px;
    font-size: 20px;
  }

  .winTagline02 {
    font-size: 20px;
  }
}

.nissan-quiz-claimbutton {
  left: 0;
  right: 0;
  bottom: 30px;
  width: 60%;
  padding: 35px;
  border-width: 2px;
  border-color: #FFFFFF;
  border-style: solid;
  background-color: #000;
  color: #FFFFFF;
  display: table;
  margin: 20px auto 60px;
  font-size: 25px;
  text-align: center;
  &.active {
    color: #FFFFFF;
  }

  &.selected {
    background-color: #FFFFFF;
    color: #000000;
  }

  &.disabled {
    opacity: 0.5;
  }
}
</style>
